import { w as withConfigTransport } from "../../../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _VaDropdownContent } from "./VaDropdownContent-c324cf24.mjs";
const VaDropdownContent = withConfigTransport(_VaDropdownContent);
export {
  VaDropdownContent as V
};
//# sourceMappingURL=index-0209c7a0.mjs.map
